import {Button, Grid, Typography} from "@material-ui/core";
import {Add} from "@material-ui/icons";
import React from "react";

export default (props) => {
    return (
        <Grid container alignItems="center">
            <Grid item sm={6} xs={12}>
                <Typography variant="h1">
                    {props.heading}
                </Typography>
            </Grid>
            <Grid item container sm={6} xs={12} justify="flex-end" alignItems="center">
                {props.children}
                <Button variant="contained" color="primary"
                        onClick={props.onClick}
                        startIcon={<Add/>}>
                    {props.label ? props.label : "New"}
                </Button>
            </Grid>
        </Grid>
    )
}